import { useQuery } from '@tanstack/react-query';
import { fetchUserCreditHistory } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';
import { ExtractFnReturnType } from '../../utils/react-query/react-query';

export const useUserCreditHistory = (userId?: string) => {
  // Make query key dynamic with userId to prevent cache reuse during impersonation
  // If userId is provided, include it in the key; otherwise use static key
  // Backend will use correct userId from JWT token regardless
  const queryKey = userId
    ? [...QUERY_KEYS.USER_CREDIT_HISTORY.LIST, userId]
    : [...QUERY_KEYS.USER_CREDIT_HISTORY.LIST, 'default'];

  return useQuery<ExtractFnReturnType<typeof fetchUserCreditHistory>>({
    queryKey,
    queryFn: fetchUserCreditHistory,
    staleTime: 0, // Always consider stale to ensure fresh data
    gcTime: 0, // Don't cache data - always fetch fresh (critical for impersonation)
    refetchOnMount: 'always', // Always refetch on mount to ensure fresh data
    refetchOnWindowFocus: true,
  });
};
